import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=1145fae1&scoped=true&"
import script from "./Header.vue?vue&type=script&setup=true&lang=js&"
export * from "./Header.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1145fae1",
  null
  
)

export default component.exports